export * from './Page_SandboxFHIR.js';
//# sourceMappingURL=index.js.map